module.exports = __webpack_public_path__ + "static/media/orange_card_bg.bf94f217.png";